import React, { useEffect, useRef, useState } from "react";

//design imports from material
import {
  Grid,
  FormControl,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Radio,
  RadioGroup,
  FormControlLabel,
  Box,
  Autocomplete,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import * as XLSX from "xlsx";
//layout import
import Layout from "../../../layout/Layout";
import dayjs from "dayjs";
import axios from "axios";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import OutlinedInput from "@mui/material/OutlinedInput";
import ListItemText from "@mui/material/ListItemText";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";

//form imports
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";

import {
  config,
  _numberOnly,
  projectMasterAPI,
  statusMasterAPI,
  vendorAPI,
  purchaseOrderAPI,
  termsAndConditionsAPI,
  userData,
  manageCompaniesAPI,
  handleHrMasterAPI,
} from "../../../config";
import { AlertMessage } from "../../../components/AlertMessage";

import NavigationGuard from "../../../layout/NavigationGuard";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
// const names = ["KG Terms & Conditions", "Validity"];
let total = 0;
let cgst = 0;
let igst = 0;
let sgst = 0;
let totalAmount = 0;

function PurchaseOrder() {
  const childRef = useRef();
  const navigate = useNavigate();

  // add field
  const [serviceList, setServiceList] = useState([
    { txtItemName: "", txtUnits: "", txtDiscountType: "percentage" },
  ]);
  const [totalWithoutGST, setTotalWithoutGST] = useState(0);
  const [totalCgst, settotalCgst] = useState(0);
  const [totalSgst, setTotalSgst] = useState(0);
  const [totalIgst, setTotalIgst] = useState(0);
  const [totalamount, setTotalAmount] = useState(0);

  const [unitsFlag, setUnitsFlag] = useState(false);
  const [txtSiteEng, setTextSiteEng] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [excelData, setExcelData] = useState([]);

  const handleServiceAdd = () => {
    setServiceList([
      ...serviceList,
      { txtItemName: "", txtUnits: "", txtDiscountType: "percentage" },
    ]);
  };

  const handleServiceRemove = (index) => {
    const list = [...serviceList];

    // Get the item that you're going to remove
    const removedItem = list[index];

    // Calculate the values to subtract
    const subtractWithoutGST = removedItem.intLineItemTotalWithoutGST;
    const subtractCGST = removedItem.intCGST;
    const subtractSGST = removedItem.intSGST;
    const subtractIGST = removedItem.intIGST;
    const subtractTotalWithGST = removedItem.intLineItemTotalWithGST;

    // Update the state variables
    setTotalWithoutGST((prevTotal) => prevTotal - subtractWithoutGST);
    settotalCgst((prevTotalCgst) => prevTotalCgst - subtractCGST);
    setTotalSgst((prevTotalSgst) => prevTotalSgst - subtractSGST);
    setTotalIgst((prevTotalIgst) => prevTotalIgst - subtractIGST);
    setTotalAmount((prevTotalAmount) => prevTotalAmount - subtractTotalWithGST);

    // Remove the item from the list
    list.splice(index, 1);

    // Update the serviceList state
    setServiceList(list);
  };

  const handleServiceChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...serviceList];

    list[index][name] = value;

    // Apply per-item discount to the base amount before GST
    const rawSubtotal =
      parseFloat(list[index]["intAmount"] || 0) *
      parseFloat(list[index]["intQuantity"] || 0);

    const discType = list[index]["txtDiscountType"] || "";
    const discVal = parseFloat(list[index]["fltDiscountValue"] || 0);

    let discountedSubtotal = rawSubtotal;
    if (discType === "fixed") {
      discountedSubtotal = Math.max(0, rawSubtotal - discVal);
    } else if (discType === "percentage") {
      discountedSubtotal = Math.max(
        0,
        rawSubtotal - (rawSubtotal * discVal) / 100,
      );
    }

    list[index]["intLineItemTotalWithoutGST"] = discountedSubtotal;

    let tempGST = parseInt(list[index]["intGST"] || 0) / 2;

    if (vendorDetails.state != "TamilNadu") {
      list[index]["intIGST"] =
        (tempGST / 100) * discountedSubtotal +
        (tempGST / 100) * discountedSubtotal;
    } else {
      list[index]["intCGST"] = (tempGST / 100) * discountedSubtotal;
      list[index]["intSGST"] = (tempGST / 100) * discountedSubtotal;
    }

    list[index]["intTGST"] = list[index]["intCGST"] + list[index]["intsGST"];

    if (vendorDetails.state != "TamilNadu") {
      list[index]["intLineItemTotalWithGST"] =
        discountedSubtotal + list[index]["intIGST"];
    } else {
      list[index]["intLineItemTotalWithGST"] =
        discountedSubtotal + list[index]["intCGST"] + list[index]["intSGST"];
    }

    total = 0;
    for (var i = 0; i < list.length; i++) {
      total = total + (list[i]["intLineItemTotalWithoutGST"] || 0);
    }
    igst = 0;
    for (var i = 0; i < list.length; i++) {
      igst = igst + (list[i]["intIGST"] || 0);
    }
    cgst = 0;
    for (var i = 0; i < list.length; i++) {
      cgst = cgst + (list[i]["intCGST"] || 0);
    }
    sgst = 0;
    for (var i = 0; i < list.length; i++) {
      sgst = sgst + (list[i]["intSGST"] || 0);
    }
    totalAmount = 0;
    for (var i = 0; i < list.length; i++) {
      totalAmount = totalAmount + (list[i]["intLineItemTotalWithGST"] || 0);
    }

    setTotalWithoutGST(total);
    setServiceList(list);

    if (igst > 0) {
      settotalCgst(0);
      setTotalSgst(0);
      setTotalIgst(igst);
    } else {
      setTotalIgst(0);
      settotalCgst(cgst);
      setTotalSgst(sgst);
    }

    setTotalAmount(totalAmount + transportCharge);
  };

  const validationSchema = Yup.object().shape({
    txtOrderType: Yup.string().required("Order Type is required"),
    txtCompanyName: Yup.string().required("Company Name is required"),
    intVendorID: Yup.string().required("Vendor Name is required"),
    intProjectID: Yup.string().required("Project Name is required"),
    //txtTermsOfPayments: Yup.string().required("Mode/Terms of Payment is required" ),
    txtPurchaseClassify: Yup.string().required(
      "Purchase classification is required",
    ),
    txtSiteEng: Yup.string().required("Site Engineer is required"),
  });
  const [orderType, setorderType] = useState(0);

  const formOptions = { resolver: yupResolver(validationSchema) };

  const { register, handleSubmit, reset, formState, setValue, watch } =
    useForm(formOptions);

  const { errors } = formState;

  const [PoDate, setPoDate] = React.useState(dayjs().format("YYYY-MM-DD"));

  // Vendor List
  const [vendorList, setVendorList] = useState([]);
  const [intVendorID, setVendorID] = useState(0);

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 3,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = vendorAPI;

      axios(config)
        .then(function (response) {
          setVendorList(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });

      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  let tempRefs = useRef(false);

  const filteredVendors = vendorList?.filter((vendor) =>
    vendor.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const [companyName, setCompanyName] = React.useState("");

  //Marital Details
  const [ProjectNameList, setProjectNameList] = useState([]);
  const [intProjectID, setProjectName] = useState(0);
  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 6,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = projectMasterAPI;

      axios(config)
        .then(function (response) {
          setProjectNameList(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  //Terms Of Payments
  // const [termsofPayments, setTermsofPayments] = useState([]);

  // tempRefs.current = false;

  // useEffect(() => {
  //   if (tempRefs.current === false) {
  //     const data = {
  //       intType: 2,
  //       intParentId: 59,
  //     };

  //     config.method = "POST";
  //     config.data = JSON.stringify(data);
  //     config.url = statusMasterAPI;

  //     axios(config)
  //       .then(function (response) {
  //         setTermsofPayments(response.data.result);
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //       });
  //     return () => {
  //       tempRefs.current = true;
  //     };
  //   }
  // }, []);

  // dispatch
  // const [dispatch, setDispatch] = useState([]);
  // const [txtDispatchThrough, setDispatchThrough] = useState("");
  // tempRefs.current = false;

  // useEffect(() => {
  //   if (tempRefs.current === false) {
  //     const data = {
  //       intType: 2,
  //       intParentId: 65,
  //     };

  //     config.method = "POST";
  //     config.data = JSON.stringify(data);
  //     config.url = statusMasterAPI;

  //     axios(config)
  //       .then(function (response) {
  //         setDispatch(response.data.result);
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //       });
  //     return () => {
  //       tempRefs.current = true;
  //     };
  //   }
  // }, []);

  // Purchase
  const [unitsList, setUnitsList] = useState([]);

  tempRefs.current = false;
  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 2,
        intParentId: 88,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = statusMasterAPI;

      axios(config)
        .then(function (response) {
          setUnitsList(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  // Purchase
  const [Purchase, setPurchase] = useState([]);
  const [txtPurchaseClassify, settxtPurchase] = useState("");
  tempRefs.current = false;

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 2,
        intParentId: 68,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = statusMasterAPI;

      axios(config)
        .then(function (response) {
          setPurchase(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  tempRefs.current = false;

  const [siteEngineer, setSiteEngineer] = useState([]);

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 12,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = handleHrMasterAPI;

      axios(config)
        .then(function (response) {
          setSiteEngineer(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  const findPhoneNumber = (id) => {
    const contact = siteEngineer.find((person) => person.id === id);
    contact && setValue("txtSiteEngContact", contact.phone_no);
  };

  tempRefs.current = false;

  // Vendor Details
  const [vendorDetails, setVendorDetails] = useState({});

  const handleVendor = (e) => {
    setVendorID(e.target.value);
    setValue("intVendorID", e.target.value);

    const data = {
      intType: 7,
      intvendorAutoID: e.target.value,
      intLimit: 1,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = vendorAPI;

    axios(config)
      .then(function (response) {
        setVendorDetails(response.data.result[0]);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const [projectDetails, setProjectDetails] = useState([]);
  const handleProject = (id) => {
    const data = {
      intType: 2,
      intProjectID: id,
      intLimit: 1,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = projectMasterAPI;

    axios(config)
      .then(function (response) {
        // console.log("Project Details: ", response.data.result[0]);
        setProjectDetails(response.data.result[0]);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  tempRefs.current = false;

  // Purchase
  const [termsNames, setTermsNames] = useState([]);

  tempRefs.current = false;

  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 4,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = termsAndConditionsAPI;

      axios(config)
        .then(function (response) {
          setTermsNames(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  tempRefs.current = false;

  const [termsName, setTermsName] = useState("");
  const [termsDescription, setTermsDescription] = useState(null);

  const handleChangeterm = (event) => {
    setTermsName(event.target.value);

    const data = {
      intType: 3,
      intID: event.target.value,
      intLimit: 1,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = termsAndConditionsAPI;

    axios(config)
      .then(function (response) {
        const fetchedDescription = response.data.result[0]?.description || "";
        setValue("txtTermsDescription", fetchedDescription);
        setTermsDescription(response.data.result[0].description);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // useEffect(() => {
  //   // Initialize TinyMCE
  //   if (termsDescription !== null) {
  //     window.tinymce.init({
  //       selector: "#textarea",
  //       width: "100%",
  //       menubar: false,
  //       plugins:
  //         "anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount",
  //       toolbar:
  //         "undo redo | fontsize | bold italic underline strikethrough | align lineheight | numlist bullist indent outdent",
  //     });

  //     setTimeout(function () {
  //       window.tinymce.get("textarea").setContent(termsDescription);
  //     }, 150);

  //     return () => {
  //       window.tinymce.remove();
  //     };
  //   }
  // }, [termsDescription]);

  const [transportGST, setTransportGST] = useState(0);
  const [transportAmount, setTransportAmount] = useState(0);
  const [transportCharge, setTransportCharge] = useState(0);

  const handleTransportCharge = (price, v) => {
    if (v != "") {
      let GstValue = (price / 100) * parseInt(v);

      let total = isNaN(parseInt(GstValue) + parseInt(price))
        ? 0
        : parseInt(GstValue) + parseInt(price);

      setTransportCharge(total);
      setTotalAmount(totalAmount + total);
    } else {
      let GstValue = (price / 100) * parseInt(transportGST);

      let total = isNaN(parseInt(GstValue) + parseInt(price))
        ? 0
        : parseInt(GstValue) + parseInt(price);

      setTransportCharge(total);

      setTotalAmount(totalAmount + total);
    }
  };

  const [baseuploadagreement, setBaseUploadAgreement] = useState("");

  const uploadagreement = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const isExcel =
      file.type === "application/vnd.ms-excel" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    if (isExcel) {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        setExcelData(jsonData);
        setBaseUploadAgreement(file.name); // Set filename just for identifier
      };
      reader.readAsArrayBuffer(file);
    } else {
      const base64 = await convertBase64(file);
      setBaseUploadAgreement(base64);
      setExcelData([]); // Clear Excel preview
    }
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => resolve(fileReader.result);
      fileReader.onerror = (error) => reject(error);
    });
  };

  const [companyNames, setCompanyNames] = React.useState("");
  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 5,
        // intParentId: 42,
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = manageCompaniesAPI;

      axios(config)
        .then(function (response) {
          // console.log("Comany address: ", response.data.result);
          setCompanyNames(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  const twoDecimal = (x) => {
    return Number.parseFloat(x).toFixed(2);
  };
  function roundUpToInteger(value) {
    // Round up to the nearest integer
    const roundedValue = Math.ceil(value);

    // Append ".00" to the rounded value
    const formattedValue = roundedValue.toFixed(2);

    return formattedValue;
  }

  const [PoTerm, setPOTerm] = React.useState(0);

  function onSubmit(data) {
    if (serviceList.length <= 0) {
      childRef.current.triggerAlert(
        JSON.stringify({
          message: "At least 1 PO Item is required",
          messageType: "error",
        }),
      );
      return;
    } else {
      const invalidIndex = serviceList.findIndex((item) => {
        return (
          isNaN(item.intLineItemTotalWithGST) ||
          item.intLineItemTotalWithGST === ""
        );
      });

      if (invalidIndex !== -1) {
        childRef.current.triggerAlert(
          JSON.stringify({
            message: `Fill all the details at S.no ${invalidIndex + 1}`,
            messageType: "error",
          }),
        );
        return;
      }

      // Validate per-item percentage discount
      const discountErrIndex = serviceList.findIndex(
        (item) =>
          item.txtDiscountType === "percentage" &&
          parseFloat(item.fltDiscountValue) > 100,
      );
      if (discountErrIndex !== -1) {
        childRef.current.triggerAlert(
          JSON.stringify({
            message: `Item ${discountErrIndex + 1}: Discount percentage cannot exceed 100%`,
            messageType: "error",
          }),
        );
        return;
      }
    }

    if (PoTerm == 0) {
      childRef.current.triggerAlert(
        JSON.stringify({
          message: "Terms & Conditions is required",
          messageType: "error",
        }),
      );
      return;
    }

    // let poDesc = window.tinymce.get("textarea").getContent();
    let poDesc = document.getElementById("textarea")?.value;

    if (!poDesc || poDesc.trim() === "") {
      throw new Error("Text area is empty. Please provide some content.");
    }

    let newPoDesc = poDesc.replaceAll("<p>", "");
    let finalPoDesc = newPoDesc.replaceAll("</p>", "");
    data.txtFile = baseuploadagreement;

    data.lineItems = serviceList;
    data.intTotalWithoutGST = totalWithoutGST;

    if (totalIgst > 0) {
      data.intTotalSGST = 0;
      data.intTotalCGST = 0;
      data.intTotalIGST = twoDecimal(totalIgst);
    } else if (totalCgst > 0 && totalSgst > 0) {
      data.intTotalIGST = 0;
      data.intTotalSGST = twoDecimal(totalSgst);
      data.intTotalCGST = twoDecimal(totalCgst);
    }
    data.txtPOValidTo = PoDate;
    data.intTotalWithGST = twoDecimal(totalamount);
    data.intCreatedBy = userData.emp_id;
    data.intVendorID = intVendorID;
    data.intStatus = 98;
    data.intTransportGst = transportGST;
    data.intTransportAmount = transportAmount;
    data.intTransportCharge = transportCharge;
    data.txtTermsHeading = PoTerm;
    data.txtTerms = finalPoDesc;

    const address = {
      type: addressType === "branch" ? 2 : addressType === "default" ? 1 : 1,
      address: addressType === "branch" ? selectedAddress : "",
    };
    data.txtAddress = JSON.stringify(address);

    // console.log("Submitting with addressType:", addressType);
    // console.log("intAddressType being sent:", data.intAddressType);

    data.intType = 1;
    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = purchaseOrderAPI;

    axios(config)
      .then(function (response) {
        // console.log("Purchase Order: ", response);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: response.data.message,
            messageType: "success",
          }),
        );

        setTimeout(function () {
          navigate(`/purchase-order/list`);
        }, 1000);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const [isCancelPopup, setIsCancelPopup] = useState(false);

  const handleCancelFile = async () => {
    setBaseUploadAgreement("");
    document.getElementById("agreementdocument").value = "";
    setIsCancelPopup(false);
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [addressType, setAddressType] = useState("");
  const [autoOpen, setAutoOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");
  const lastSelectedProjectIdRef = useRef(null);

  const handleCompanyFieldClick = () => {
    setAutoOpen(true);
  };

  const handleAutoCompleteClose = () => {
    setAutoOpen(false);
  };

  const handleProjectSelection = (newValue) => {
    if (newValue && typeof newValue === "object") {
      const projectId = newValue.id;

      setProjectName(projectId || "");
      setValue("intProjectID", projectId || "");
      handleProject(projectId || "");

      const selectedProject = ProjectNameList.find(
        (project) => project.id === projectId,
      );

      const isBranchCompany = (companyId) => {
        return companyId === 22 || companyId === 31;
      };

      if (selectedProject) {
        setProjectDetails(selectedProject);

        if (isBranchCompany(companyName)) {
          setDialogOpen(true);
        } else {
          setSelectedAddress(selectedProject.project_address);
          setAddressType("default");
        }
        lastSelectedProjectIdRef.current = projectId;
      }
    }
    setAutoOpen(false);
  };

  // top of file, above the component
  const GST_RATES = [0, 5, 18, 40];

  return (
    <Layout>
      <AlertMessage ref={childRef} />
      <Grid className="employee-form">
        <Grid item xs={12} lg={12} md={12}>
          <Grid container spacing={3}>
            <Grid
              textAlign="center"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <Typography className="page_title" textAlign="left">
                {orderType == 1
                  ? "Purchase Order"
                  : orderType == 2
                    ? "Work Order"
                    : "Purchase Order"}
              </Typography>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/dashboard">
                  Dashboard
                </Link>
                <Typography color="text.primary">
                  {orderType == 1
                    ? "Purchase Order"
                    : orderType == 2
                      ? "Work Order"
                      : "Purchase Order"}
                </Typography>
                <Typography color="text.primary">create</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid
              textAlign="right"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <LoadingButton
                size="medium"
                variant="contained"
                color="secondary"
                className="button_first"
                href="/purchase-order/list"
              >
                List{" "}
                {orderType == 1
                  ? "Purchase Order"
                  : orderType == 2
                    ? "Work Order"
                    : "Purchase Order"}
              </LoadingButton>
              <LoadingButton
                size="medium"
                variant="contained"
                color="primary"
                onClick={() => navigate(-1)}
                startIcon={<ArrowBackIosIcon />}
              >
                Back
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
        <div className="empty-space-40"></div>
        <Grid className="purchaseorder">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container className="popading" spacing={2}>
              <Grid
                item
                className="form-lable po_lebleterm"
                xs={12}
                lg={3}
                md={3}
              >
                <FormControl fullWidth variant="outlined">
                  {/* Autocomplete with Searchable Dropdown */}
                  <Autocomplete
                    options={[
                      { id: "1", name: "Purchase Order" },
                      { id: "2", name: "Work Order" },
                    ]}
                    getOptionLabel={(option) => option?.name || ""}
                    value={
                      [
                        { id: "1", name: "Purchase Order" },
                        { id: "2", name: "Work Order" },
                      ].find((order) => order.id === watch("txtOrderType")) ||
                      null
                    }
                    onChange={(event, newValue) => {
                      setValue("txtOrderType", newValue?.id || "");
                      setorderType(newValue?.id); // Update Formik value
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Order Type"
                        placeholder="Search Order Type"
                        variant="outlined"
                      />
                    )}
                  />

                  {/* Validation Error Message */}
                  {errors?.txtOrderType?.message && (
                    <Typography className="invalid-feedback">
                      {errors.txtOrderType.message}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              <Grid
                item
                className="form-lable po_lebleterm"
                xs={12}
                lg={3}
                md={3}
              >
                <FormControl fullWidth variant="outlined">
                  <Autocomplete
                    options={filteredVendors ?? []}
                    getOptionLabel={(option) => option?.name || ""}
                    value={
                      (vendorList ?? []).find(
                        (vendor) => vendor.id === intVendorID,
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      if (newValue && typeof newValue === "object") {
                        handleVendor({ target: { value: newValue.id || "" } });
                        setVendorID(newValue.id || "");
                      } else {
                        setVendorID("");
                        setVendorDetails({});
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Vendor Name"
                        placeholder="Search Vendor"
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    )}
                  />

                  {/* Validation Error Message */}
                  {errors?.intVendorID?.message && (
                    <Typography className="invalid-feedback">
                      {errors.intVendorID.message}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              <Grid
                item
                className="form-lable po_lebleterm"
                xs={12}
                lg={3}
                md={3}
              >
                <FormControl fullWidth variant="outlined">
                  {/* Autocomplete with Searchable Dropdown */}
                  <Autocomplete
                    options={Array.isArray(companyNames) ? companyNames : []} // Ensure it's an array
                    getOptionLabel={(option) => option?.company_name || ""}
                    value={
                      Array.isArray(companyNames)
                        ? companyNames.find(
                            (company) => company.id === companyName,
                          ) || null
                        : null
                    }
                    onChange={(event, newValue) => {
                      setCompanyName(newValue?.id || "");
                      setValue("txtCompanyName", newValue?.id || ""); // Update Formik value
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Company Name"
                        placeholder="Search Company"
                        variant="outlined"
                      />
                    )}
                  />

                  {/* Validation Error Message */}
                  {errors?.txtCompanyName?.message && (
                    <Typography className="invalid-feedback">
                      {errors.txtCompanyName.message}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>Select Address Type</DialogTitle>
                <DialogContent>
                  <Typography>
                    Please choose whether you want the default company address
                    or the factory address.
                  </Typography>
                  <RadioGroup
                    value={addressType}
                    onChange={(e) => {
                      const selectedType = e.target.value;
                      setAddressType(selectedType);

                      if (selectedType === "default") {
                        setSelectedAddress(projectDetails.project_address);
                      }
                    }}
                  >
                    <FormControlLabel
                      value="default"
                      control={<Radio />}
                      label="Default Address"
                    />
                    <FormControlLabel
                      value="branch"
                      control={<Radio />}
                      label="Factory Address"
                    />
                    {addressType === "branch" && (
                      <>
                        <TextField
                          label="Address"
                          multiline
                          rows={6}
                          value={selectedAddress}
                          onChange={(e) => setSelectedAddress(e.target.value)}
                          fullWidth
                        />
                        <Button
                          variant="primary"
                          className={`btn-primary`}
                          onClick={() => {
                            setDialogOpen(false);
                          }}
                        >
                          Add Address
                        </Button>
                      </>
                    )}
                  </RadioGroup>
                </DialogContent>
              </Dialog>

              <Grid
                item
                className="form-lable po_lebleterm"
                xs={12}
                lg={3}
                md={3}
              >
                <FormControl fullWidth variant="outlined">
                  <Autocomplete
                    options={
                      Array.isArray(ProjectNameList) ? ProjectNameList : []
                    }
                    getOptionLabel={(option) => option?.name || ""}
                    value={
                      Array.isArray(ProjectNameList)
                        ? ProjectNameList.find(
                            (project) => project.id === intProjectID,
                          ) || null
                        : null
                    }
                    onChange={(event, newValue) => {
                      if (newValue && typeof newValue === "object") {
                        lastSelectedProjectIdRef.current = newValue.id;
                      } else {
                        setProjectName("");
                        setValue("intProjectID", "");
                        setProjectDetails({});
                        setSelectedAddress("");
                        setAddressType("");
                        lastSelectedProjectIdRef.current = null;
                      }
                    }}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        onClick={() => {
                          handleProjectSelection(option);
                          if (
                            option?.id === lastSelectedProjectIdRef.current &&
                            (companyName === 22 || companyName === 31)
                          ) {
                            setDialogOpen(true);
                          }
                        }}
                      >
                        {option.name}
                      </li>
                    )}
                    onOpen={handleCompanyFieldClick}
                    open={autoOpen}
                    onClose={handleAutoCompleteClose}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Project"
                        placeholder="Search Project"
                        variant="outlined"
                      />
                    )}
                  />

                  {/* Validation Error Message */}
                  {errors?.intProjectID?.message && (
                    <Typography className="invalid-feedback">
                      {errors.intProjectID.message}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
            </Grid>

            <Grid container className="pomargin table_po">
              <Grid container spacing={2} className="po_leble">
                {/* Column 1: Vendor Details */}
                <Grid item xs={12} lg={3} md={3} className="form-lable">
                  <Grid className="info_details">
                    <Typography variant="h6" sx={{ fontSize: "20px" }}>
                      Bill to
                    </Typography>
                    {vendorDetails.hasOwnProperty("name") && (
                      <>
                        <Typography className="companyna">
                          {vendorDetails.name}
                        </Typography>
                        <Typography>{vendorDetails.mobile_no}</Typography>
                        <Typography>
                          {vendorDetails.street_address}, {vendorDetails.city}
                        </Typography>
                        <Typography>
                          {vendorDetails.pincode} {vendorDetails.state}
                        </Typography>
                        <Typography>India</Typography>
                        <Typography>GSTIN {vendorDetails.gst}</Typography>
                      </>
                    )}
                  </Grid>
                </Grid>

                {/* Column 2: Project Details */}
                <Grid item xs={12} lg={3} md={3} className="form-lable">
                  <Grid className="info_details">
                    <Typography variant="h6" sx={{ fontSize: "20px" }}>
                      Place of Supply:
                    </Typography>
                    {addressType === "default" ? (
                      projectDetails.hasOwnProperty("name") && (
                        <>
                          <Typography className="companyna">
                            {projectDetails.project_address}
                          </Typography>

                          <Typography>{projectDetails.city}</Typography>
                          <Typography>
                            {projectDetails.pincode} {projectDetails.state}
                          </Typography>
                          <Typography>India</Typography>
                        </>
                      )
                    ) : (
                      <Typography>{selectedAddress}</Typography>
                    )}
                  </Grid>
                </Grid>

                {/* Column 3: Other Details */}
                <Grid
                  item
                  xs={12}
                  lg={6}
                  md={6}
                  sx={{ border: "1px solid #000", mt: 2 }}
                >
                  {/* Supplier Ref./Quotation No. */}
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    className="po_leble"
                  >
                    <Grid item xs={12} lg={5} md={5} className="lable_text">
                      <Typography>Supplier Ref :</Typography>
                    </Grid>
                    <Grid item xs={12} lg={7} md={7}>
                      <TextField
                        name="familyname"
                        type="text"
                        sx={{ width: "100%" }}
                        {...register("txtQuotationNo")}
                      />
                    </Grid>
                  </Grid>

                  {/* Purchase Classification */}
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    className="po_leble"
                  >
                    <Grid item xs={12} lg={5} md={5} className="lable_text">
                      <Typography>
                        {orderType == 1
                          ? "PO classification"
                          : orderType == 2
                            ? "WO classification"
                            : "PO classification"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} lg={7} md={7}>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={txtPurchaseClassify}
                          onChange={(e) => {
                            settxtPurchase(e.target.value);
                            setValue("txtPurchaseClassify", e.target.value);
                          }}
                        >
                          {Purchase.map((row, index) => (
                            <MenuItem value={row.id} key={index}>
                              {row.name}
                            </MenuItem>
                          ))}
                        </Select>
                        <Typography className="invalid-feedback">
                          {errors.txtPurchaseClassify?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                  </Grid>

                  {/* Site Engineer */}
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    className="po_leble"
                  >
                    <Grid item xs={12} lg={5} md={5} className="lable_text">
                      <Typography>Site Engineer:</Typography>
                    </Grid>
                    <Grid item xs={12} lg={7} md={7}>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={txtSiteEng}
                          onChange={(e) => {
                            setTextSiteEng(e.target.value);
                            findPhoneNumber(e.target.value);
                            setValue("txtSiteEng", e.target.value);
                          }}
                        >
                          {siteEngineer.length > 0 ? (
                            siteEngineer.map((row, index) => (
                              <MenuItem value={row.id} key={index}>
                                {row.name}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem>No data found</MenuItem>
                          )}
                        </Select>
                        <Typography className="invalid-feedback">
                          {errors.txtSiteEng?.message}
                        </Typography>
                      </FormControl>
                    </Grid>
                  </Grid>

                  {/* Site Engineer Contact */}
                  {txtSiteEng && (
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      className="po_leble"
                    >
                      <Grid item xs={12} lg={5} md={5} className="lable_text">
                        <Typography>Site Engineer Contact</Typography>
                      </Grid>
                      <Grid item xs={12} lg={7} md={7}>
                        <TextField
                          name="siteEngineerContact"
                          type="text"
                          {...register("txtSiteEngContact")}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>

              <Grid item className="form-lable" xs={12} lg={12} md={12}>
                <table className={`table`}>
                  <thead>
                    <th style={{ width: "5%" }}>
                      <Typography>S. No.</Typography>
                    </th>
                    <th style={{ width: "28%" }}>
                      <Typography>Description</Typography>
                    </th>
                    <th style={{ width: "10%" }}>
                      <Typography>UNO </Typography>
                    </th>
                    <th style={{ width: "12%" }}>
                      <Typography>Rate </Typography>
                    </th>
                    <th style={{ width: "10%" }}>
                      <Typography>Discount</Typography>
                    </th>
                    <th style={{ width: "10%" }}>
                      <Typography>GST </Typography>
                    </th>
                    <th style={{ width: "10%" }}>
                      <Typography>Total Amount Without GST</Typography>
                    </th>
                    <th style={{ width: "5%" }} className="add_button">
                      <Tooltip title="Add New" arrow>
                        <Button
                          variant="outlined"
                          onClick={handleServiceAdd}
                          startIcon={<AddIcon />}
                          color="success"
                        ></Button>
                      </Tooltip>
                    </th>
                  </thead>
                  <tbody>
                    {serviceList.map((singleService, index) => (
                      <tr className="table_padding">
                        <td className={`text-center`}>
                          <Typography>{index + 1}</Typography>
                        </td>
                        <td className="po_leble">
                          <TextField
                            name="txtItemName"
                            type="text"
                            id="txtItemName"
                            value={singleService.txtItemName}
                            onChange={(e) => handleServiceChange(e, index)}
                            required
                            fullWidth
                            multiline
                            // or whatever max you prefer
                            style={{ width: "100%" }}
                          />
                        </td>

                        <td className="po_leble">
                          <Select
                            name="txtUnits"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={singleService.txtUnits}
                            style={{ width: "100%" }}
                            onChange={(e) => {
                              setUnitsFlag(true);
                              handleServiceChange(e, index);
                            }}
                          >
                            {unitsList.length > 0 &&
                              unitsList.map((row, index) => (
                                <MenuItem value={row.id} key={index}>
                                  {row.name}
                                </MenuItem>
                              ))}
                          </Select>
                          {unitsFlag && (
                            <TextField
                              name="intQuantity"
                              type="number"
                              value={singleService.intQuantity}
                              onChange={(e) => handleServiceChange(e, index)}
                              inputProps={{
                                min: 1.0,
                                step: "any",
                              }}
                              style={{ width: "100%", marginTop: "5px" }}
                            />
                          )}
                        </td>
                        <td className="po_leble">
                          <TextField
                            name="intAmount"
                            type="number"
                            // {...register("intAmount")}
                            value={singleService.intAmount}
                            onChange={(e) => handleServiceChange(e, index)}
                            style={{ width: "100%" }}
                          />
                        </td>

                        {/* ── Per-item Discount ── */}
                        <td className="po_leble">
                          <FormControl
                            fullWidth
                            size="small"
                            style={{ marginBottom: 4 }}
                          >
                            <Select
                              displayEmpty
                              name="txtDiscountType"
                              value={singleService.txtDiscountType || ""}
                              onChange={(e) => handleServiceChange(e, index)}
                            >
                              <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              <MenuItem value="percentage">
                                Percentage (%)
                              </MenuItem>
                              <MenuItem value="fixed">(Rs. )Fixed</MenuItem>
                            </Select>
                          </FormControl>
                          {singleService.txtDiscountType && (
                            <TextField
                              name="fltDiscountValue"
                              type="number"
                              size="small"
                              placeholder={
                                singleService.txtDiscountType === "percentage"
                                  ? "0–100"
                                  : "Rs. Amount"
                              }
                              value={singleService.fltDiscountValue || ""}
                              inputProps={{
                                min: 0,
                                max:
                                  singleService.txtDiscountType === "percentage"
                                    ? 100
                                    : undefined,
                                step: "any",
                              }}
                              error={
                                singleService.txtDiscountType ===
                                  "percentage" &&
                                parseFloat(singleService.fltDiscountValue) > 100
                              }
                              helperText={
                                singleService.txtDiscountType ===
                                  "percentage" &&
                                parseFloat(singleService.fltDiscountValue) > 100
                                  ? "Max 100%"
                                  : ""
                              }
                              onChange={(e) => handleServiceChange(e, index)}
                              onKeyDown={(e) =>
                                ["e", "E", "-", "+"].includes(e.key) &&
                                e.preventDefault()
                              }
                              style={{ width: "100%" }}
                            />
                          )}
                        </td>

                        <td className="po_leble">
                          <FormControl fullWidth>
                            <Select
                              labelId="demo-simple-select-label"
                              name="intGST"
                              id="demo-simple-select"
                              value={singleService.intGST}
                              onChange={(e) => {
                                handleServiceChange(e, index);
                              }}
                              style={{ width: "100%" }}
                            >
                              {GST_RATES.map((r) => (
                                <MenuItem value={`${r}`} key={r}>
                                  GST {r}%
                                </MenuItem>
                              ))}
                            </Select>
                            <Typography className="invalid-feedback">
                              {errors.intGST?.message}
                            </Typography>
                          </FormControl>
                        </td>

                        <td className="po_leble">
                          <Typography textAlign="right">
                            {isNaN(singleService.intLineItemTotalWithoutGST)
                              ? `0.00`
                              : twoDecimal(
                                  singleService.intLineItemTotalWithoutGST,
                                )}
                          </Typography>
                        </td>
                        <td className="cancel_button">
                          {serviceList.length !== 1 && (
                            <>
                              <div
                                style={{
                                  textAlign: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Button
                                  variant="outlined"
                                  onClick={(e) => {
                                    handleServiceChange(e, index);
                                    handleServiceRemove(index);
                                  }}
                                  startIcon={<DeleteIcon />}
                                  color="error"
                                ></Button>

                                <small
                                  style={{ fontSize: "13px", fontWeight: "90" }}
                                >
                                  Remove
                                </small>
                              </div>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tbody className="tbody_col">
                    <tr className="table_padding_40">
                      <td className={`text-center`}>
                        <Typography></Typography>
                      </td>
                      <td colSpan={5}>
                        <Typography>Total amount</Typography>
                      </td>
                      <td colSpan={2}>
                        <Typography value={totalWithoutGST}>
                          {isNaN(totalWithoutGST)
                            ? `0.00`
                            : twoDecimal(totalWithoutGST)}
                        </Typography>
                      </td>
                    </tr>
                    {vendorDetails.state != "TamilNadu" ? (
                      <>
                        <tr className="table_padding_40">
                          <td className={`text-center`}>
                            <Typography></Typography>
                          </td>
                          <td colSpan={5}>
                            <Typography>IGST </Typography>
                          </td>
                          <td colSpan={2}>
                            <Typography value={totalIgst}>
                              {isNaN(totalIgst)
                                ? `0.00`
                                : twoDecimal(totalIgst)}
                            </Typography>
                          </td>
                        </tr>
                      </>
                    ) : (
                      <>
                        <tr className="table_padding_40">
                          <td className={`text-center`}>
                            <Typography></Typography>
                          </td>
                          <td colSpan={5}>
                            <Typography>CGST </Typography>
                          </td>
                          <td colSpan={2}>
                            <Typography value={totalCgst}>
                              {isNaN(totalCgst)
                                ? `0.00`
                                : twoDecimal(totalCgst)}
                            </Typography>
                          </td>
                        </tr>
                        <tr className="table_padding_40">
                          <td className={`text-center`}>
                            <Typography></Typography>
                          </td>
                          <td colSpan={5}>
                            <Typography>SGST </Typography>
                          </td>
                          <td colSpan={2}>
                            <Typography value={totalSgst}>
                              {isNaN(totalSgst)
                                ? `0.00`
                                : twoDecimal(totalSgst)}
                            </Typography>
                          </td>
                        </tr>
                      </>
                    )}
                    <tr className="table_padding_40">
                      <td className={`text-center`}>
                        <Typography></Typography>
                      </td>
                      <td colSpan={3}>
                        <Typography>Transport Charges</Typography>
                      </td>
                      <td className="po_leble">
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            name="intTransportGST"
                            id="demo-simple-select"
                            {...register("intTransportGST")}
                            onChange={(e) => {
                              setValue("intTransportGST", e.target.value);
                              setTransportGST(e.target.value);

                              if (transportAmount != 0) {
                                handleTransportCharge(
                                  transportAmount,
                                  e.target.value,
                                );
                              }
                            }}
                          >
                            {GST_RATES.map((r) => (
                              <MenuItem value={`${r}`} key={r}>
                                GST {r}%
                              </MenuItem>
                            ))}
                          </Select>
                          <Typography className="invalid-feedback">
                            {errors.intGST?.message}
                          </Typography>
                        </FormControl>
                      </td>
                      <td className="po_leble">
                        <TextField
                          name="intTransportAmount"
                          type="number"
                          {...register("intTransportAmount")}
                          onChange={(e) => {
                            setTransportAmount(e.target.value);
                            handleTransportCharge(e.target.value, "");
                          }}
                        />
                      </td>
                      <td colSpan={2}>
                        <Typography value={transportCharge}>
                          {isNaN(transportCharge)
                            ? `0.00`
                            : twoDecimal(transportCharge)}
                        </Typography>
                      </td>
                    </tr>
                    <tr className="table_padding_40">
                      <td className={`text-center`}>
                        <Typography></Typography>
                      </td>
                      <td colSpan={5}>
                        <Typography>Total amount with GST </Typography>
                      </td>
                      <td colSpan={2}>
                        <Typography value={totalamount}>
                          {isNaN(totalamount)
                            ? `0.00`
                            : twoDecimal(totalamount)}
                        </Typography>
                      </td>
                    </tr>

                    <tr className="table_padding_40">
                      <td className={`text-center`}>
                        <Typography></Typography>
                      </td>
                      <td colSpan={5}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: "20px",
                          }}
                        >
                          Total Payable Amount (Rs.)
                        </Typography>
                      </td>
                      <td colSpan={2}>
                        <Typography
                          value={totalamount}
                          variant="subtitle1"
                          sx={{
                            fontWeight: "bold",
                            fontSize: "20px",
                          }}
                        >
                          {isNaN(totalamount)
                            ? `0.00 /-`
                            : `${roundUpToInteger(totalamount)} /-`}
                        </Typography>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            </Grid>
            <div className="empty-space-20"></div>
            <Grid
              item
              xs={12}
              md={4}
              lg={4}
              textAlign="left"
              className="po_lebleterm"
            >
              <FormControl className="form_control" sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-checkbox-label">
                  Terms & Conditions
                </InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  value={termsName}
                  onChange={handleChangeterm}
                  input={<OutlinedInput label="Terms & Conditions" />}
                  MenuProps={MenuProps}
                >
                  {termsNames.map((terms) => (
                    <MenuItem key={terms.title} value={terms.id}>
                      <ListItemText
                        primary={terms.title}
                        onClick={() => {
                          setPOTerm(terms.id);
                        }}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {termsDescription !== null && (
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                textAlign={`right`}
                display={`flex`}
                justifyContent={`flex-end`}
              >
                {/* <TextField fullWidth id="textarea" /> */}
                <TextField
                  fullWidth
                  multiline
                  minRows={4}
                  maxRows={6}
                  id="textarea"
                  // label="Description"
                  {...register("txtTermsDescription")}
                />
              </Grid>
            )}

            <Grid></Grid>
            <Grid
              item
              className="form-lable"
              xs={12}
              lg={4}
              md={4}
              sx={{ mt: 4 }}
            >
              <label> Document : </label>
              <br />
              <small className="" style={{ fontSize: "12px" }}>
                Allowed Only *.jpeg, *.jpg, *.png, *.pdf , *.xls, *.xlsx
              </small>
              <br></br>
              <Box display={`flex`}>
                <Button variant="contained" component="label">
                  <input
                    id="agreementdocument"
                    name="agreementdocument"
                    type="file"
                    accept="image/jpeg,image/png,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    fullWidth
                    onChange={(e) => {
                      uploadagreement(e);
                    }}
                  />
                </Button>
                {baseuploadagreement != "" && (
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => setIsCancelPopup(true)}
                    style={{ marginLeft: "10px" }}
                  >
                    Remove
                  </Button>
                )}
              </Box>
            </Grid>
            <Grid></Grid>
            {baseuploadagreement !== "" && (
              <Grid item className="form-lable" xs={12} lg={12} md={12}>
                <Grid item xs={12} sm={12}>
                  <Typography variant="h6">Document</Typography>
                  {baseuploadagreement.endsWith(".pdf") ? (
                    <iframe
                      src={baseuploadagreement}
                      title="document"
                      width="100%"
                      height="600"
                    ></iframe>
                  ) : baseuploadagreement.startsWith(
                      "data:application/pdf;base64,",
                    ) ? (
                    <iframe
                      src={`data:application/pdf;base64,${
                        baseuploadagreement.split(",")[1]
                      }`}
                      title="document"
                      width="100%"
                      height="600"
                    ></iframe>
                  ) : excelData.length > 0 ? (
                    <Table>
                      <TableBody>
                        {excelData.map((row, rowIndex) => (
                          <TableRow key={rowIndex}>
                            {row.map((cell, colIndex) => (
                              <TableCell key={colIndex}>{cell}</TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  ) : (
                    <img
                      src={baseuploadagreement}
                      alt="document"
                      style={{ maxWidth: "100%" }}
                    />
                  )}
                </Grid>
              </Grid>
            )}

            <div className="empty-space-20"></div>
            <Grid item xs={12} md={12} lg={12} textAlign="right">
              <Button variant="primary" className={`btn-primary`} type="submit">
                Submit
              </Button>
            </Grid>
          </form>
        </Grid>
      </Grid>
      <Dialog
        open={isCancelPopup}
        onClose={() => setIsCancelPopup(false)}
        maxWidth="xl"
      >
        <DialogTitle sx={{ backgroundColor: "#FFF2D7" }}>
          <Typography
            variant="h5"
            style={{
              color: "#FF6868",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Warning!!
          </Typography>
        </DialogTitle>
        <DialogContent style={{ padding: "16px" }}>
          <Typography variant="h6">
            Would you like to remove the attachment?
          </Typography>
          <Typography
            variant="body2"
            style={{ color: "#f44336", fontWeight: "bold" }}
          >
            **This step cannot be undone
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center", padding: "16px" }}>
          <Button color="success" onClick={handleCancelFile}>
            Yes
          </Button>
          <Button color="error" onClick={() => setIsCancelPopup(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <>
        <NavigationGuard />
      </>
    </Layout>
  );
}

export default PurchaseOrder;
